import { TapEvent } from '@iotize/tap';

export interface TapLoginEvent extends TapEvent<'tap-login'> {}
export interface TapLogoutEvent extends TapEvent<'tap-logout'> {}

export interface TapUserPasswordChangeEvent
  extends TapEvent<'tap-user-password-change'> {
  user: {
    id: number;
    // username: string;
  };
}
export interface UsernamePassword {
  username: string;
  password: string;
}

export interface AuthMethod<LoginParam, SessionDataType> {
  login(params: LoginParam): Promise<SessionDataType>;

  logout(): Promise<void>;

  changePassword(newPassword: string, groupId: number): Promise<void>;
}

// export interface TapEncryptionInterface {

//     start();

//     stop();
// }
